export const LoudMegaphone = <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <g clip-path="url(#clip0_555_5858)">
    <path d="M9.59862 1.88609L5.69741 10.2067L2.02015 13.884C1.40995 14.4942 1.40995 15.4835 2.02015 16.0937L3.12503 17.1986C3.73522 17.8088 4.72456 17.8088 5.33476 17.1986L9.01202 13.5213L17.3326 9.62012M18.4375 10.7249L8.49378 0.78125M16.8472 4.71527L18.4375 3.90625M14.5035 2.37152L15.3125 0.78125"
      stroke="currentColor"
      stroke-width="1.5625"
      stroke-miterlimit="1"
      stroke-linecap="round"
      stroke-linejoin="round"/>
    <path d="M6.8025 15.7308L9.81649 18.7448C10.1004 19.0371 10.4977 19.2188 10.9375 19.2188C11.8004 19.2188 12.5 18.5191 12.5 17.6563C12.5 17.2165 12.3183 16.8192 12.026 16.5353L5.69739 10.2067"
      stroke="currentColor"
      stroke-width="1.5625"
      stroke-miterlimit="1"
      stroke-linecap="round"
      stroke-linejoin="round"/>
  </g>
  <defs>
    <clipPath id="clip0_555_5858">
      <rect width="20" height="20"/>
    </clipPath>
  </defs>
</svg>